const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./provider-fullcont-handler')

export function start(detail) {
    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    load: { start: (detail) => { load(detail) } },
    submit: { start: (detail) => { submit(detail) } },
    typing: { start: (detail) => { typing(detail) } },
    beforeChat: { start: (detail) => { beforeChat(detail) } },
}

const PROVIDER_QUESTIONS = [
    "Outstanding debt to provider?",
    "Recent orders?",
]

function getGeneralQuestions(type) {
    if (type === "provider") {
        return PROVIDER_QUESTIONS
    }
}

function load(detail) {

    const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
    const recordId = fullcontActivo.getAttribute('data-dbid')

    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: ${detail.dest}
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: Provider
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    ID: ${recordId}
                </div>
            </div>
        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history of this provider
                </div>
            </div>
        </div>
    `;

    if (recordId) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "provider",
                "entity": "provider",
                "question": detail.question ?? "",
                "generalQuestions": getGeneralQuestions("provider"),
                "recordId": recordId,
                "ev": detail.ev,
                "cardWarning": cardWarning,
            }
        )

        const msj = handler.getChatsFc();
        chat.start({
            "dest": "chat",
            "act": "load",
            "chats": msj,
            "generalQuestions": getGeneralQuestions("provider"),
            "cardWarning": cardWarning,
        })
    }

}

function typing(detail) {
    chatHandler.typing(detail)
}